<main class="main">
  <app-header
    [isAuthenticated]="isAuthenticated()"
    [isMobile]="isMobile"
    (toggleMenu)="toggleSidenav()"
  />
  <div class="content">
    @if (loadingService.loading()) {
    <app-loading-overlay></app-loading-overlay>
    } @if(isAuthenticated()){

    <div class="left-side">
      <mat-sidenav-container class="sidenav-container">
        @if (!hideMenu()) {
        <mat-sidenav
          #drawer
          [mode]="sidenavMode"
          [opened]="isMobile ? showNavList : true"
          (closedStart)="showNavList = false"
          [autoFocus]="false"
        >
          @if(sidenavMenuItems() && sidenavMenuItems().length > 0){
          <h2 class="p-5 font-bold">{{ "sidenav.menuTitle" | transloco }}</h2>
          <mat-nav-list class="nav-list">
            @for (item of sidenavMenuItems(); track item.title) {
            <a
              class="mb-[12px]"
              mat-list-item
              [routerLink]="item.route"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isMobile && drawer.close()"
            >
              <div class="flex align-middle">
                <mat-icon class="mr-[10px] h-[20px] w-[18px]">{{
                  item.icon
                }}</mat-icon>
                <span class="nav-button-tittle">{{
                  item.title | transloco
                }}</span>

                <!-- EL NÚMERO DE NOTIFICACIONES Y CHATS ESTÁ MOCKEADO. HAY QUE CONTROLAR EL ESTADO CUANDO TENGAMOS BACKEND -->
                @if(item.route === '/notifications'){
                <span class="ml-[10px] nav-button-tittle">{{
                  notificationsCount
                }}</span>
                }@else if (item.route === '/messages') {
                <span class="ml-[76px] nav-button-tittle">{{
                  chatsCount
                }}</span>
                }
              </div>
            </a>
            }
          </mat-nav-list>
          }
          <h2 class="p-4 font-bold">
            {{ "sidenav.profileTitle" | transloco }}
          </h2>
          <mat-nav-list class="nav-list">
            @for (item of sidenavProfileItems(); track item.title) {
            @if(item.route !== '/logout'){
            <a
              class="mb-[10px]"
              mat-list-item
              [routerLink]="item.route"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isMobile && drawer.close()"
            >
              <div class="flex align-middle">
                <mat-icon class="mr-[10px] h-[20px] w-[18px]">{{
                  item.icon
                }}</mat-icon>
                <span class="nav-button-tittle">{{
                  item.title | transloco
                }}</span>
              </div>
            </a>
            } @else {
            <a class="mb-[10px]" mat-list-item (click)="logout()">
              <div class="flex align-middle">
                <mat-icon class="mr-[10px] h-[20px] w-[18px]">{{
                  item.icon
                }}</mat-icon>
                <span class="nav-button-tittle">{{
                  item.title | transloco
                }}</span>
              </div>
            </a>
            } }
          </mat-nav-list>
        </mat-sidenav>
        }
        <mat-sidenav-content class="sidenav-container__content">
          <router-outlet (activate)="isMobile && (showNavList = false)" />
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
    }@else {
    <router-outlet />
    }
  </div>
</main>
